import { IProjectProfitabilityQueryParam } from "models/project";
import { Dispatch } from "redux";
import { setProjectCount, setProjects } from "./reducer";
import { toast } from "react-toastify";

export const getProjectProfitability = (query?: IProjectProfitabilityQueryParam) => async (dispatch: Dispatch) => {
    try {
        let queryString = '';
        if (query) {
            const params = new URLSearchParams();

            Object.entries(query).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') return;

                if (Array.isArray(value)) {
                    value.forEach(v => {
                        if (v) params.append(key, v);
                    });
                } else {
                    params.append(key, String(value));
                }
            });

            queryString = params.toString();
        }

        const url = `${process.env.REACT_APP_API_URL}/project/project-profitability${queryString ? `?${queryString}` : ''}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        dispatch(setProjects(data.data.data));
        dispatch(setProjectCount(data.data.count));

    } catch (err: any) {
        toast.error(err.message ?? "Error getting projects");
    }
}

export const downloadProjectProfitabilityCSV = async (query?: IProjectProfitabilityQueryParam) => {
    try {
        let queryString = '';
        if (query) {
            const params = new URLSearchParams();

            Object.entries(query).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') return;

                if (Array.isArray(value)) {
                    value.forEach(v => {
                        if (v) params.append(key, v);
                    });
                } else {
                    params.append(key, String(value));
                }
            });

            queryString = params.toString();
        }

        const url = `${process.env.REACT_APP_API_URL}/project/project-profitability/export${queryString ? `?${queryString}` : ''}`;

        const res = await fetch(url, {
            credentials: "include",
            method: "GET",
        });

        if (!res.ok) {
            const errBody = await res.json().catch(() => null);
            throw new Error(errBody?.message ?? "Failed to export CSV");
        }

        // Blob → downloadable file
        const blob = await res.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `project_profitability_${Date.now()}.csv`;
        a.click();

        window.URL.revokeObjectURL(blobUrl);
        toast.success("Exported project profitability.")

    } catch (err: any) {
        toast.error(err.message ?? "Error downloading CSV");
    }
};